(function () {
  function initHero(scope) {
    var heroSlider = scope.querySelector('[data-lsc-hero-slider]');
    if (!heroSlider || heroSlider.dataset.sliderReady === 'true') return;
    heroSlider.dataset.sliderReady = 'true';

    var sectionRoot = heroSlider.closest('.shopify-section') || heroSlider.parentElement;
    var heroSlides = Array.prototype.slice.call(heroSlider.querySelectorAll('[data-lsc-hero-slide]'));
    var heroDots = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-lsc-hero-dot]'));
    var heroFrame;
    var heroAutoTimer;
    var heroActiveIndex = 0;
    var heroMobileQuery = window.matchMedia('(max-width: 767px)');
    var heroReduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setHeroDot(index) {
      heroActiveIndex = index;
      heroDots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    function stopHeroAuto() {
      window.clearTimeout(heroAutoTimer);
    }
    function scrollHeroTo(index) {
      if (!heroSlides.length) return;
      var nextIndex = (index + heroSlides.length) % heroSlides.length;
      var paddingLeft = parseFloat(window.getComputedStyle(heroSlider).paddingLeft) || 0;
      heroSlider.scrollTo({
        left: Math.max(0, heroSlides[nextIndex].offsetLeft - paddingLeft),
        behavior: 'smooth'
      });
      setHeroDot(nextIndex);
    }
    function scheduleHeroAuto(delay) {
      stopHeroAuto();
      if (!heroMobileQuery.matches || heroReduceMotionQuery.matches || document.hidden) return;
      heroAutoTimer = window.setTimeout(function () {
        scrollHeroTo(heroActiveIndex + 1);
        scheduleHeroAuto(5000);
      }, delay || 5000);
    }

    heroDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollHeroTo(parseInt(dot.getAttribute('data-lsc-hero-dot') || '0', 10));
        scheduleHeroAuto(7000);
      });
    });
    heroSlider.addEventListener('scroll', function () {
      window.cancelAnimationFrame(heroFrame);
      heroFrame = window.requestAnimationFrame(function () {
        var sliderLeft = heroSlider.getBoundingClientRect().left + (parseFloat(window.getComputedStyle(heroSlider).paddingLeft) || 0);
        var nearest = 0;
        var distance = Infinity;
        heroSlides.forEach(function (slide, index) {
          var nextDistance = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });
        setHeroDot(nearest);
      });
    }, { passive: true });
    heroSlider.addEventListener('pointerdown', stopHeroAuto, { passive: true });
    heroSlider.addEventListener('pointerup', function () { scheduleHeroAuto(7000); }, { passive: true });
    heroSlider.addEventListener('pointercancel', function () { scheduleHeroAuto(7000); }, { passive: true });
    heroSlider.addEventListener('focusin', stopHeroAuto);
    heroSlider.addEventListener('focusout', function () { scheduleHeroAuto(7000); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopHeroAuto();
      else scheduleHeroAuto(5000);
    });
    if (heroMobileQuery.addEventListener) {
      heroMobileQuery.addEventListener('change', function () { scheduleHeroAuto(5000); });
    } else if (heroMobileQuery.addListener) {
      heroMobileQuery.addListener(function () { scheduleHeroAuto(5000); });
    }
    heroSlider.__lscStopAuto = stopHeroAuto;
    scheduleHeroAuto(5000);
  }

  function initProductCarousels(scope) {
    var carousels = scope.querySelectorAll('[data-lsc-product-carousel]');
    carousels.forEach(function (carousel) {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      var section = carousel.closest('.lsc-products');
      var previous = section && section.querySelector('[data-lsc-product-prev]');
      var next = section && section.querySelector('[data-lsc-product-next]');
      var frame;
      var dragging = false;
      var dragged = false;
      var startX = 0;
      var startScroll = 0;

      function scrollAmount() {
        var card = carousel.querySelector('.lsc-product-card');
        if (!card) return carousel.clientWidth;
        var styles = window.getComputedStyle(carousel);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return (card.getBoundingClientRect().width + gap) * 2;
      }

      function updateButtons() {
        var max = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        if (previous) previous.disabled = carousel.scrollLeft <= 3;
        if (next) next.disabled = carousel.scrollLeft >= max - 3;
      }

      function move(direction) {
        carousel.scrollBy({ left: direction * scrollAmount(), behavior: 'smooth' });
      }

      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      carousel.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateButtons);
      }, { passive: true });

      carousel.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button, input')) return;
        dragging = true;
        dragged = false;
        startX = event.clientX;
        startScroll = carousel.scrollLeft;
        carousel.classList.add('is-dragging');
        carousel.setPointerCapture(event.pointerId);
      });
      carousel.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var distance = event.clientX - startX;
        if (Math.abs(distance) > 5) dragged = true;
        carousel.scrollLeft = startScroll - distance;
      });
      function stopDragging(event) {
        if (!dragging) return;
        var shouldSuppressClick = dragged;
        dragging = false;
        carousel.classList.remove('is-dragging');
        if (carousel.hasPointerCapture && carousel.hasPointerCapture(event.pointerId)) carousel.releasePointerCapture(event.pointerId);
        if (shouldSuppressClick) window.setTimeout(function () { dragged = false; }, 120);
      }
      carousel.addEventListener('pointerup', stopDragging);
      carousel.addEventListener('pointercancel', stopDragging);
      carousel.addEventListener('click', function (event) {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
      window.addEventListener('resize', updateButtons, { passive: true });
      updateButtons();
    });
  }

  function readCardMoney(node) {
    var raw = node && node.textContent ? node.textContent.replace(/[^0-9.,-]/g, '') : '';
    return parseFloat(raw.replace(/,/g, '')) || 0;
  }

  function normalizeProductCardOffers(scope) {
    scope.querySelectorAll('.lsc-product-card').forEach(function (card) {
      var media = card.querySelector('.lsc-product-card__image');
      var price = card.querySelector('.lsc-price');
      if (!media || !price) return;

      var current = readCardMoney(price.querySelector('strong'));
      var compare = readCardMoney(price.querySelector('s'));
      var badge = media.querySelector('.lsc-product-badge');

      if (!(compare > current && current > 0)) {
        if (badge) badge.remove();
        return;
      }

      var percentage = Math.round(((compare - current) * 100) / compare);
      if (percentage < 1) {
        if (badge) badge.remove();
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'lsc-product-badge';
        media.appendChild(badge);
      }

      badge.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.59 13.41 11.41 22.59a2 2 0 0 1-2.82 0L1.41 15.41A2 2 0 0 1 1 14V4a3 3 0 0 1 3-3h10a2 2 0 0 1 1.41.59l7.18 7.18a2 2 0 0 1 0 2.82ZM6.5 8A1.5 1.5 0 1 0 6.5 5a1.5 1.5 0 0 0 0 3Z"/></svg> SAVE ' + percentage + '%';
    });
  }

  function initHome() {
    var root = document.querySelector('[data-lsc-home]');
    if (!root) return;
    normalizeProductCardOffers(root);
    initHero(root);
    initProductCarousels(root);
    if (root.dataset.eventsReady === 'true') return;
    root.dataset.eventsReady = 'true';

    root.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var input = event.target.closest('.lsc-qty').querySelector('input[name="quantity"]');
      var value = Math.max(1, parseInt(input.value || '1', 10));
      input.value = minus ? Math.max(1, value - 1) : value + 1;
    });

    var toast = root.querySelector('[data-lsc-toast]');
    var toastTimer;
    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
    }

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('.lsc-product-form');
      if (!form || !window.fetch) return;
      event.preventDefault();
      var button = form.querySelector('.lsc-add-button');
      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'ADDING...';

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add item.'); });
          return response.json();
        })
        .then(function () {
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (response) { return response.json(); });
        })
        .then(function (cartData) {
          document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cartData.item_count; });
          showToast('Added to cart.');
          document.dispatchEvent(new CustomEvent('rv:cart:updated',{detail:{open:true,message:'Added to your cart'}}));
        })
        .catch(function (error) {
          showToast(error.message || 'Unable to add item.');
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = original;
        });
    });
  }

  initHome();
  document.addEventListener('shopify:section:load', initHome);
  document.addEventListener('shopify:section:unload', function (event) {
    var slider = event.target.querySelector('[data-lsc-hero-slider]');
    if (slider && slider.__lscStopAuto) slider.__lscStopAuto();
  });
})();

